import Firebase from "firebase"

Firebase.initializeApp({
  apiKey: "AIzaSyBlqTl1yMgFVnrmF9JA65HYp8rc_n2HLWA",
  authDomain: "vital-signs-db.firebaseapp.com",
  databaseURL: "https://vital-signs-db.firebaseio.com",
  projectId: "vital-signs-db",
  storageBucket: "vital-signs-db.appspot.com",
  messagingSenderId: "150979668551",
})

export const firebase = Firebase

export const UNSTUCK_BLUE = "#00B2BE"
export const UNSTUCK_GREEN = "#B1C63A"

export const BACKGROUND = "#F3F2F1"
export const BORDER = "rgba(16,17,47,0.1)"
export const SECONDARY_TEXT = "#A8A8A8"
export const PRIMARY_TEXT = "#3B3B3B"

window.firebase = Firebase



// WEBPACK FOOTER //
// ./src/constants.js